const Hamburger = (function() {

  const $Trigger = $('#js-hamburger-trigger');

  return {
    init() {

      if($Trigger.length) {

        this.setEvent();
      }
    },
    setEvent() {

      $Trigger.on('click', function() {

        const $target = $('[data-sp-nav-is-open]');
        const newValue = $target.attr('data-sp-nav-is-open') === 'true' ? 'false' : 'true';
        $target.attr('data-sp-nav-is-open', newValue);
      });
    },
  }
})();

Hamburger.init();